export default __webpack_public_path__ + "static/media/tms.915720ee.svg";